import React, { ReactNode } from 'react';
import SubItem from './SubItem';

interface SubCardProps {
  title: string;
  subtitle?: string;
  children?: ReactNode;
}

const SubCard: React.FC<SubCardProps> = ({ title, subtitle="", children }) => {
  return (
    <>
        <SubItem title={title} subtext={subtitle} />
        {children}
    </>
  )
};

export default SubCard;